// FRONTEND/src/contexts/MaintenanceContext.js
import React, { createContext, useContext, useMemo, useState } from "react";

const MaintenanceContext = createContext(null);

export const MaintenanceProvider = ({ children }) => {
  const [maintenance, setMaintenance] = useState({
    active: false,
    message: "",
    startsAt: null,
    endsAt: null,
  });

  const value = useMemo(() => ({ maintenance, setMaintenance }), [maintenance]);

  return (
    <MaintenanceContext.Provider value={value}>
      {children}
    </MaintenanceContext.Provider>
  );
};

export const useMaintenance = () => {
  const ctx = useContext(MaintenanceContext);

  // Safe fallback so app never crashes
  if (!ctx) {
    return {
      maintenance: { active: false, message: "", startsAt: null, endsAt: null },
      setMaintenance: () => {},
    };
  }

  return ctx;
};